import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../../../assets/logo.svg";
import signupImg from "../../../assets/signup-img.png";
import useAuth from "../../../hooks/useAuth";
import useLocation from "../../../hooks/useLocation";

const RegisterPage = () => {
  const navigate = useNavigate();
  const { register, loading, error } = useAuth();
  const {
    cities,
    districts,
    fetchCities,
    fetchDistricts,
    loading: locationLoading,
    setCities,
    setDistricts,
  } = useLocation();

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    password: "",
    cityId: "",
    districtId: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [selectedCity, setSelectedCity] = useState("");

  // Şehirleri getir
  useEffect(() => {
    fetchCities()
      .then((data) => {})
      .catch((err) => {
        console.error("❌ Şehirler getirilemedi:", err);
      });
  }, []);

  // Şehir seçildiğinde ilçeleri getir
  useEffect(() => {
    if (selectedCity) {
      fetchDistricts(selectedCity)
        .then((data) => {})
        .catch((err) => {
          console.error("❌ İlçeler getirilemedi:", err);
        });
    }
  }, [selectedCity]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Şehir değiştiğinde ilçeleri getir
    if (name === "cityId") {
      setSelectedCity(value);
      setFormData({
        ...formData,
        cityId: value,
        districtId: "", // Şehir değiştiğinde ilçeyi sıfırla
      });
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    // Hataları temizle
    if (formErrors[name]) {
      setFormErrors({
        ...formErrors,
        [name]: "",
      });
    }
  };

  const validateForm = () => {
    let isValid = true;
    const errors = {};

    // Ad Soyad kontrolü
    if (!formData.name.trim()) {
      errors.name = "Ad Soyad zorunludur";
      isValid = false;
    }

    // E-posta kontrolü
    if (!formData.email.trim()) {
      errors.email = "E-posta zorunludur";
      isValid = false;
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      errors.email = "Geçerli bir e-posta adresi giriniz";
      isValid = false;
    }

    // Telefon kontrolü
    if (!formData.phone.trim()) {
      errors.phone = "Telefon numarası zorunludur";
      isValid = false;
    } else if (!/^[0-9]{10}$/.test(formData.phone.replace(/\D/g, ""))) {
      errors.phone = "Geçerli bir telefon numarası giriniz (10 haneli)";
      isValid = false;
    }

    // Şifre kontrolü
    if (!formData.password) {
      errors.password = "Şifre zorunludur";
      isValid = false;
    } else if (formData.password.length < 8) {
      errors.password = "Şifre en az 8 karakter olmalıdır";
      isValid = false;
    }

    // Şehir kontrolü
    if (!formData.cityId) {
      errors.cityId = "Şehir seçimi zorunludur";
      isValid = false;
    }

    // İlçe kontrolü
    if (!formData.districtId) {
      errors.districtId = "İlçe seçimi zorunludur";
      isValid = false;
    }

    setFormErrors(errors);
    return isValid;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    try {
      // API'ye gönderilecek veriyi hazırla
      const userData = {
        name: formData.name,
        email: formData.email,
        phone: formData.phone,
        password: formData.password,
        cityId: parseInt(formData.cityId),
        districtId: parseInt(formData.districtId),
      };

      // Kayıt işlemini gerçekleştir
      const result = await register(userData);

      // Başarılı kayıt sonrası giriş sayfasına yönlendir
      alert("Kayıt işlemi başarılı! Giriş sayfasına yönlendiriliyorsunuz.");
      navigate("/auth/login");
    } catch (err) {
      console.error("Kayıt hatası:", err);
      // Hata mesajını göster
      setFormErrors({
        ...formErrors,
        general: err.message || "Kayıt işlemi sırasında bir hata oluştu",
      });
    }
  };

  return (
    // Ana kapsayıcı: Küçük ekranlarda dikey, md ve üzerinde yatay
    <div className="min-h-screen bg-white flex flex-col md:flex-row">
      {/* Sol Taraf - Görsel ve Açıklama */}
      {/* Küçük ekranlarda gizle, md ve üzerinde göster ve yarı genişlik */}
      <div className="hidden md:block md:w-1/2 relative">
        <img
          src={signupImg}
          alt="Temizlik Hizmeti"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-black/40 flex items-center">
          <div className="text-white px-8 lg:px-16 max-w-full md:max-w-[520px]">
            <p className="text-base lg:text-lg leading-7">
              Yıkafoni şirketi Halı yıkama, Koltuk yıkama, Perde yıkama, Yorgan
              yıkama, Yatak yıkama konusunda Türkiye'nin tüm il ve ilçe
              merkezlerinde yaygın bayi ağı ile hizmet vermektedir.
            </p>
          </div>
        </div>
      </div>

      {/* Sağ Taraf - Kayıt Formu */}
      {/* Küçük ekranlarda tam genişlik, md ve üzerinde yarı genişlik. Padding ayarları. */}
      <div className="w-full md:w-1/2 flex items-center justify-center p-4 sm:p-8">
        {/* İçerik: Genişliği küçük ekranlarda ayarla */}
        <div className="w-full max-w-[384px] flex-col justify-start items-center gap-6 inline-flex">
          {/* Logo ve Başlık */}
          <div className="self-stretch flex-col justify-start items-center gap-4 flex">
            <div className="w-48 h-20 relative">
              <img
                src={logo}
                alt="Yıkafoni Logo"
                className="w-[200px] h-[50px]"
              />
              <div className="w-32 text-center text-[#4F46E5] text-xs tracking-wider font-bold mt-1">
                TEMİZLİK BURADA
              </div>
            </div>
            <div className="self-stretch flex-col justify-start items-start gap-2 flex">
              <div className="self-stretch text-center text-black text-2xl font-semibold leading-loose">
                Hesap Oluştur
              </div>
              <div className="self-stretch text-center text-black/40 text-sm leading-tight">
                Dakikalar içerisinde ihtiyaçlarınızı satın almaya başlayın!
              </div>
            </div>
          </div>

          {/* Form */}
          <form
            onSubmit={handleSubmit}
            className="self-stretch flex-col justify-start items-end gap-4 flex"
          >
            <div className="self-stretch flex-col justify-start items-start gap-3 flex">
              {/* Genel Hata Mesajı */}
              {formErrors.general && (
                <div className="self-stretch p-2 bg-red-50 border border-red-300 rounded-lg text-red-700 text-sm">
                  {formErrors.general}
                </div>
              )}

              {/* Ad Soyad */}
              <div className="self-stretch h-16 flex-col justify-start items-start flex">
                <div className="self-stretch pb-2 justify-start items-center gap-1 inline-flex">
                  <div className="text-black/90 text-sm font-medium leading-tight">
                    Ad Soyad
                  </div>
                </div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Ad Soyad giriniz"
                  className="self-stretch h-10 px-3 bg-white rounded-lg border border-black/20 text-sm leading-tight placeholder-black/25 focus:outline-none focus:ring-2 focus:ring-[#4F46E5]"
                />
                {formErrors.name && (
                  <div className="text-red-500 text-xs mt-1">
                    {formErrors.name}
                  </div>
                )}
              </div>

              {/* E-posta */}
              <div className="self-stretch h-16 flex-col justify-start items-start flex">
                <div className="self-stretch pb-2 justify-start items-center gap-1 inline-flex">
                  <div className="text-black/90 text-sm font-medium leading-tight">
                    E Posta
                  </div>
                </div>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="E Posta adresinizi giriniz"
                  className="self-stretch h-10 px-3 bg-white rounded-lg border border-black/20 text-sm leading-tight placeholder-black/25 focus:outline-none focus:ring-2 focus:ring-[#4F46E5]"
                />
                {formErrors.email && (
                  <div className="text-red-500 text-xs mt-1">
                    {formErrors.email}
                  </div>
                )}
              </div>

              {/* Telefon */}
              <div className="self-stretch h-16 flex-col justify-start items-start flex">
                <div className="self-stretch pb-2 justify-start items-center gap-1 inline-flex">
                  <div className="text-black/90 text-sm font-medium leading-tight">
                    Telefon
                  </div>
                </div>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="Telefon numaranızı giriniz"
                  className="self-stretch h-10 px-3 bg-white rounded-lg border border-black/20 text-sm leading-tight placeholder-black/25 focus:outline-none focus:ring-2 focus:ring-[#4F46E5]"
                />
                {formErrors.phone && (
                  <div className="text-red-500 text-xs mt-1">
                    {formErrors.phone}
                  </div>
                )}
              </div>

              {/* Şehir */}
              <div className="self-stretch h-16 flex-col justify-start items-start flex">
                <div className="self-stretch pb-2 justify-start items-center gap-1 inline-flex">
                  <div className="text-black/90 text-sm font-medium leading-tight">
                    Şehir
                  </div>
                </div>
                <select
                  name="cityId"
                  value={formData.cityId}
                  onChange={handleChange}
                  className="self-stretch h-10 px-3 bg-white rounded-lg border border-black/20 text-sm leading-tight focus:outline-none focus:ring-2 focus:ring-[#4F46E5]"
                >
                  <option value="">Şehir Seçiniz</option>
                  {/* API'den gelen [null, [...şehirler]] yapısını ele al */}
                  {cities &&
                    Array.isArray(cities) &&
                    cities.length > 1 &&
                    Array.isArray(cities[1]) &&
                    cities[1].map(
                      (city) =>
                        // Şehir nesnesinin null veya undefined olmadığını kontrol et
                        city && (
                          <option key={city.id} value={city.id}>
                            {city.name}
                          </option>
                        )
                    )}
                </select>
                {formErrors.cityId && (
                  <div className="text-red-500 text-xs mt-1">
                    {formErrors.cityId}
                  </div>
                )}
              </div>

              {/* İlçe */}
              <div className="self-stretch h-16 flex-col justify-start items-start flex">
                <div className="self-stretch pb-2 justify-start items-center gap-1 inline-flex">
                  <div className="text-black/90 text-sm font-medium leading-tight">
                    İlçe
                  </div>
                </div>
                <select
                  name="districtId"
                  value={formData.districtId}
                  onChange={handleChange}
                  disabled={!formData.cityId || locationLoading}
                  className="self-stretch h-10 px-3 bg-white rounded-lg border border-black/20 text-sm leading-tight focus:outline-none focus:ring-2 focus:ring-[#4F46E5]"
                >
                  <option value="">İlçe Seçiniz</option>
                  {districts &&
                    districts.map((district) => (
                      <option key={district.id} value={district.id}>
                        {district.name}
                      </option>
                    ))}
                </select>
                {formErrors.districtId && (
                  <div className="text-red-500 text-xs mt-1">
                    {formErrors.districtId}
                  </div>
                )}
              </div>

              {/* Şifre */}
              <div className="self-stretch h-16 flex-col justify-start items-start flex">
                <div className="self-stretch pb-2 justify-start items-center gap-1 inline-flex">
                  <div className="text-black/90 text-sm font-medium leading-tight">
                    Şifre
                  </div>
                </div>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  placeholder="Şifre oluşturunuz"
                  className="self-stretch h-10 px-3 bg-white rounded-lg border border-black/20 text-sm leading-tight placeholder-black/25 focus:outline-none focus:ring-2 focus:ring-[#4F46E5]"
                />
                {formErrors.password && (
                  <div className="text-red-500 text-xs mt-1">
                    {formErrors.password}
                  </div>
                )}
              </div>
            </div>

            {/* Şifre Gereksinimleri */}
            <div className="self-stretch flex-col gap-1 flex mb-4">
              <div className="flex items-center gap-2">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M13.3332 4L5.99984 11.3333L2.6665 8"
                    stroke={
                      formData.password && formData.password.length >= 8
                        ? "#10B981"
                        : "#D1D5DB"
                    }
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span
                  className={`text-sm ${
                    formData.password && formData.password.length >= 8
                      ? "text-green-500"
                      : "text-black/40"
                  }`}
                >
                  En az 8 karakter olmalıdır.
                </span>
              </div>
              <div className="flex items-center gap-2">
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M13.3332 4L5.99984 11.3333L2.6665 8"
                    stroke={
                      formData.password &&
                      /[!@#$%^&*(),.?":{}|<>]/.test(formData.password)
                        ? "#10B981"
                        : "#D1D5DB"
                    }
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
                <span
                  className={`text-sm ${
                    formData.password &&
                    /[!@#$%^&*(),.?":{}|<>]/.test(formData.password)
                      ? "text-green-500"
                      : "text-black/40"
                  }`}
                >
                  Bir adet özel karakter içermelidir.
                </span>
              </div>
            </div>

            {/* Kayıt Ol Butonu */}
            <button
              type="submit"
              disabled={loading}
              className="self-stretch h-10 px-4 bg-[#4F46E5] rounded-lg shadow-[0px_2px_0px_0px_rgba(0,0,0,0.02)] text-white flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <div className="animate-spin rounded-full h-5 w-5 border-t-2 border-b-2 border-white"></div>
              ) : (
                <>
                  <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                    <path
                      d="M17.7656 17.2002L12.6934 12.1279C13.4805 11.1104 13.9062 9.86621 13.9062 8.55762C13.9062 6.99121 13.2949 5.52246 12.1895 4.41504C11.084 3.30762 9.61133 2.69824 8.04688 2.69824C6.48242 2.69824 5.00977 3.30957 3.9043 4.41504C2.79687 5.52051 2.1875 6.99121 2.1875 8.55762C2.1875 10.1221 2.79883 11.5947 3.9043 12.7002C5.00977 13.8076 6.48047 14.417 8.04688 14.417C9.35547 14.417 10.5977 13.9912 11.6152 13.2061L16.6875 18.2764C16.7024 18.2912 16.72 18.3031 16.7395 18.3111C16.7589 18.3192 16.7797 18.3233 16.8008 18.3233C16.8218 18.3233 16.8427 18.3192 16.8621 18.3111C16.8815 18.3031 16.8992 18.2912 16.9141 18.2764L17.7656 17.4268C17.7805 17.4119 17.7923 17.3942 17.8004 17.3748C17.8084 17.3554 17.8126 17.3345 17.8126 17.3135C17.8126 17.2924 17.8084 17.2716 17.8004 17.2522C17.7923 17.2327 17.7805 17.2151 17.7656 17.2002Z"
                      fill="white"
                    />
                  </svg>
                  <span className="text-base font-medium">Kayıt Ol</span>
                </>
              )}
            </button>

            {/* Google ile Kayıt */}
            <button
              type="button"
              className="self-stretch h-10 px-4 bg-white rounded-lg shadow-[0px_2px_0px_0px_rgba(0,0,0,0.02)] border border-black/20 flex items-center justify-center gap-2"
            >
              <svg width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path
                  d="M17.2076 9.15137H10.151V12.0518H14.1823C14.0084 12.9893 13.4811 13.7822 12.6862 14.3135C12.0143 14.7627 11.1569 15.0283 10.149 15.0283C8.19788 15.0283 6.54749 13.71 5.95764 11.9385C5.8092 11.4893 5.72327 11.0088 5.72327 10.5146C5.72327 10.0205 5.8092 9.54004 5.95764 9.09082C6.54944 7.32129 8.19983 6.00293 10.151 6.00293C11.2506 6.00293 12.2369 6.38184 13.0143 7.12402L15.1627 4.97363C13.8639 3.7627 12.1705 3.02051 10.151 3.02051C7.22327 3.02051 4.69006 4.7002 3.45764 7.14941C2.94983 8.16113 2.66077 9.30566 2.66077 10.5166C2.66077 11.7275 2.94983 12.8701 3.45764 13.8818C4.69006 16.3311 7.22327 18.0107 10.151 18.0107C12.1744 18.0107 13.8698 17.3389 15.108 16.1943C16.524 14.8896 17.3424 12.9678 17.3424 10.6846C17.3424 10.1533 17.2955 9.64355 17.2076 9.15137Z"
                  fill="black"
                  fillOpacity="0.88"
                />
              </svg>
              <span className="text-black/90 text-base font-medium">
                Google ile Hesap Oluştur
              </span>
            </button>

            {/* Giriş Yap Linki */}
            <div className="self-stretch flex-col justify-start items-center gap-2 flex mt-4">
              <div className="text-black/40 text-sm">Hesabınız var mı?</div>
              <Link
                to="/auth/login"
                className="text-[#4F46E5] text-sm font-medium flex items-center gap-2"
              >
                <svg width="17" height="17" viewBox="0 0 17 17" fill="none">
                  <path
                    d="M14.7125 13.8623L10.6547 9.80449C11.2844 8.99043 11.625 7.99512 11.625 6.94824C11.625 5.69512 11.1359 4.52012 10.2516 3.63418C9.36719 2.74824 8.18906 2.26074 6.9375 2.26074C5.68594 2.26074 4.50781 2.7498 3.62344 3.63418C2.7375 4.51855 2.25 5.69512 2.25 6.94824C2.25 8.1998 2.73906 9.37793 3.62344 10.2623C4.50781 11.1482 5.68438 11.6357 6.9375 11.6357C7.98438 11.6357 8.97813 11.2951 9.79219 10.667L13.85 14.7232C13.8619 14.7351 13.876 14.7446 13.8916 14.751C13.9071 14.7575 13.9238 14.7608 13.9406 14.7608C13.9575 14.7608 13.9741 14.7575 13.9897 14.751C14.0052 14.7446 14.0194 14.7351 14.0312 14.7232L14.7125 14.0436C14.7244 14.0317 14.7338 14.0175 14.7403 14.002C14.7467 13.9864 14.7501 13.9698 14.7501 13.9529C14.7501 13.9361 14.7467 13.9194 14.7403 13.9039C14.7338 13.8883 14.7244 13.8742 14.7125 13.8623Z"
                    fill="#4F46E5"
                  />
                </svg>
                Giriş Yap
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default RegisterPage;
